export default __webpack_public_path__ + "5de53865db9d737c8b662a3d4784c1d6.ttf";